const te = {
    nav: {
      home: "హోమ్",
      browse: "బతులలు బ్రౌజ్ చేయండి",
      dashboard: "డ్యాష్బోర్డ్",
      messages: "సందేశాలు",
      profile: "ప్రొఫైల్",
      login: "లాగిన్",
      register: "నమోదు",
      logout: "లాగౌట్",
      admin: "అడ్మిన్",
      faq: "సాధారణ ప్రశ్నలు",
      about: "మా గురించి",
      contact: "సంప్రదించండి",
      pricing: "ధరలు",
      howItWorks: "ఇది ఎలా పనిచేస్తుంది",
    },
    auth: {
      login: {
        title: "తిరిగి స్వాగతం",
        email: "ఇమెయిల్",
        password: "సంకేతపదం",
        button: "లాగిన్",
        noAccount: "ఖాతా లేదు?",
        register: "ఇప్పుడు నమోదు చేయండి",
      },
      register: {
        title: "ఖాతా సృష్టించండి",
        name: "పూర్తి పేరు",
        email: "ఇమెయిల్",
        password: "సంకేతపదం",
        role: "నేను కావలసినది...",
        roleHost: "తిరువుడాడు",
        roleGuest: "తిరువులోకి చేరండి",
        terms: "నేను నిబంధనలు మరియు గోప్యతा విధానాన్ని అంగీకరిస్తున్నాను",
        button: "నమోదు",
        hasAccount: "ఇప్పటికే ఖాతా ఉందా?",
        login: "ఇప్పుడు లాగిన్ చేయండి",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "లోడ్ అవుతోంది...",
      error: "దోషం ఏర్పడింది",
      success: "విజయం",
      save: "సేవ్ చేయి",
      cancel: "రద్దు",
      delete: "తొలగించు",
      edit: "సవరించు",
      back: "వెనక్కి",
      next: "తరువాత",
      language: "భాష",
      currency: "నాణయం",
      search: "వెతకండి",
      filter: "వట్టు",
      all: "మన్ని",
      none: "ఏదీ లేదు",
      yes: "అవును",
      no: "లేదు",
    },
    footer: {
      about: "మా గురించి",
      privacy: "గోప్యత",
      terms: "షరత్తులు",
      contact: "సంప్రదించండి",
      copyright: "© 2024 WEDVAYA. అన్ని హక్కులు చేపట్టబడ్డాయి.",
    },
  };

export default te;
